import { render, staticRenderFns } from "./proddelivery.vue?vue&type=template&id=c501d938&scoped=true&"
import script from "./proddelivery.vue?vue&type=script&lang=js&"
export * from "./proddelivery.vue?vue&type=script&lang=js&"
import style0 from "./proddelivery.vue?vue&type=style&index=0&id=c501d938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c501d938",
  null
  
)

export default component.exports